import _objectSpread from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import dateUtility from './DateUtility';
import { InvoiceType } from './constants';
var InvoiceService = /*#__PURE__*/function () {
  function InvoiceService(http, config) {
    _classCallCheck(this, InvoiceService);
    this.http = http;
    this.config = config;
  }
  _createClass(InvoiceService, [{
    key: "createInvoiceSync",
    value: function () {
      var _createInvoiceSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(invoice) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              invoice.company = this.config.deployment;
              _context.next = 4;
              return this.http.post('/api/invoices/create', invoice, {
                timeout: 8000
              });
            case 4:
              return _context.abrupt("return", _context.sent);
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);
              return _context.abrupt("return", {
                success: false
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function createInvoiceSync(_x) {
        return _createInvoiceSync.apply(this, arguments);
      }
      return createInvoiceSync;
    }()
  }, {
    key: "createShopInvoiceSync",
    value: function () {
      var _createShopInvoiceSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(invoice) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.http.post('/api/invoices/createshop', invoice);
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 6]]);
      }));
      function createShopInvoiceSync(_x2) {
        return _createShopInvoiceSync.apply(this, arguments);
      }
      return createShopInvoiceSync;
    }()
  }, {
    key: "createLoadInvoiceSync",
    value: function () {
      var _createLoadInvoiceSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(invoice) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.http.post('/api/invoices/createload', invoice);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              console.log(_context3.t0);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 6]]);
      }));
      function createLoadInvoiceSync(_x3) {
        return _createLoadInvoiceSync.apply(this, arguments);
      }
      return createLoadInvoiceSync;
    }()
  }, {
    key: "getInvoices",
    value: function getInvoices(customerId, isShopInvoices, callback) {
      var invoiceUrl = isShopInvoices ? '/shopinvoices/' : '/invoices/';
      this.http.get('/api/' + this.config.deployment + invoiceUrl + customerId).then(function (response) {
        callback(response.results);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "searchInvoicesByDate",
    value: function searchInvoicesByDate(fromDate, toDate, customerId, invoiceType, take, skip, callback) {
      var request = {
        fromDate: fromDate,
        toDate: toDate,
        customerId: customerId,
        isPetroff: this.config.isPetroff,
        take: take,
        skip: skip
      };
      var invoicePart = InvoiceType.getInvoicesPart(invoiceType);
      this.http.post("/api/".concat(invoicePart, "/search/date"), request).then(function (response) {
        callback(response.results);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "searchInvoicesByNumber",
    value: function searchInvoicesByNumber(number, invoiceType, take, skip, callback) {
      var request = {
        number: number,
        isPetroff: this.config.isPetroff,
        take: take,
        skip: skip
      };
      var invoicePart = InvoiceType.getInvoicesPart(invoiceType);
      this.http.post("/api/".concat(invoicePart, "/search/number"), request).then(function (response) {
        callback(response.results);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "getInvoice",
    value: function getInvoice(invoiceId, invoiceType, callback) {
      var invoiceUrlPart = "/".concat(InvoiceType.getInvoicePart(invoiceType), "/");
      this.http.get('/api/' + this.config.deployment + invoiceUrlPart + invoiceId).then(function (response) {
        var results = response.results;
        if (results.dateTowed) {
          results.dateTowed = results.dateTowed ? dateUtility.dateToString(results.dateTowed) : null;
        }
        if (results.towed) {
          results.dateTowed = results.towed ? dateUtility.dateToString(results.towed) : null;
        }
        results.paymentDate = results.paymentDate ? dateUtility.dateToString(results.paymentDate) : null;
        if (results.date) {
          results.date = results.date ? dateUtility.dateToString(results.date) : null;
        }
        callback(results);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "getTax",
    value: function () {
      var _getTax = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.http.get('/api/invoices/partsTax');
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              console.log(_context4.t0);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 6]]);
      }));
      function getTax() {
        return _getTax.apply(this, arguments);
      }
      return getTax;
    }()
  }, {
    key: "updateTax",
    value: function () {
      var _updateTax = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(tax) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.http.post('/api/invoices/partsTax', {
                tax: tax
              });
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](0);
              console.log(_context5.t0);
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 6]]);
      }));
      function updateTax(_x4) {
        return _updateTax.apply(this, arguments);
      }
      return updateTax;
    }()
  }, {
    key: "sendInvoiceSync",
    value: function () {
      var _sendInvoiceSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(email, filename, customerId, invoiceId, isShopInvoice) {
        var body;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              body = {
                email: email,
                filename: filename,
                deployment: this.config.deployment,
                customerId: customerId,
                invoiceId: invoiceId,
                isShopInvoice: isShopInvoice
              };
              _context6.prev = 1;
              _context6.next = 4;
              return this.http.post('/api/invoices/send', body, {
                timeout: 10000
              });
            case 4:
              return _context6.abrupt("return", _context6.sent);
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](1);
              console.log(_context6.t0);
              return _context6.abrupt("return", {
                failure: "Unable to send email"
              });
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 7]]);
      }));
      function sendInvoiceSync(_x5, _x6, _x7, _x8, _x9) {
        return _sendInvoiceSync.apply(this, arguments);
      }
      return sendInvoiceSync;
    }()
  }, {
    key: "sendInvoiceSyncNew",
    value: function () {
      var _sendInvoiceSyncNew = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(email, filename, customerId, invoiceId, invoiceType) {
        var body;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(invoiceType !== InvoiceType.LOAD)) {
                _context7.next = 6;
                break;
              }
              _context7.next = 3;
              return this.sendInvoiceSync(email, filename, customerId, invoiceId, InvoiceType.isShopInvoices(invoiceType));
            case 3:
              return _context7.abrupt("return", _context7.sent);
            case 6:
              body = {
                email: email,
                filename: filename,
                deployment: this.config.deployment,
                customerId: customerId,
                invoiceId: invoiceId
              };
              _context7.prev = 7;
              _context7.next = 10;
              return this.http.post('/api/loadinvoices/send', body, {
                timeout: 10000
              });
            case 10:
              return _context7.abrupt("return", _context7.sent);
            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7["catch"](7);
              console.log(_context7.t0);
              return _context7.abrupt("return", {
                failure: "Unable to send email"
              });
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[7, 13]]);
      }));
      function sendInvoiceSyncNew(_x10, _x11, _x12, _x13, _x14) {
        return _sendInvoiceSyncNew.apply(this, arguments);
      }
      return sendInvoiceSyncNew;
    }()
  }, {
    key: "getInvoiceSendStatus",
    value: function () {
      var _getInvoiceSendStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(jobId) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.http.get('/api/invoices/sendstatus/' + jobId);
            case 3:
              return _context8.abrupt("return", _context8.sent);
            case 6:
              _context8.prev = 6;
              _context8.t0 = _context8["catch"](0);
              console.log(_context8.t0);
              return _context8.abrupt("return", {
                failure: "Unable to send email"
              });
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 6]]);
      }));
      function getInvoiceSendStatus(_x15) {
        return _getInvoiceSendStatus.apply(this, arguments);
      }
      return getInvoiceSendStatus;
    }()
  }, {
    key: "createCustomerAndInvoice",
    value: function () {
      var _createCustomerAndInvoice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(isShopInvoice, invoice, customer) {
        var body, results;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              invoice.company = this.config.deployment;
              body = {
                deployment: this.config.deployment,
                isShopInvoice: isShopInvoice,
                invoice: invoice,
                customer: customer
              };
              _context9.prev = 2;
              _context9.next = 5;
              return this.http.post('/api/invoices/createCustomerAndInvoice', body, {
                timeout: 10000
              });
            case 5:
              results = _context9.sent;
              return _context9.abrupt("return", _objectSpread({
                success: true
              }, results));
            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](2);
              console.log(_context9.t0);
              return _context9.abrupt("return", {
                success: false
              });
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[2, 9]]);
      }));
      function createCustomerAndInvoice(_x16, _x17, _x18) {
        return _createCustomerAndInvoice.apply(this, arguments);
      }
      return createCustomerAndInvoice;
    }()
  }, {
    key: "updateInvoiceSync",
    value: function () {
      var _updateInvoiceSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(invoiceId, isShopInvoice, invoice) {
        var urlPart, results;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              urlPart = isShopInvoice ? 'shopinvoices' : 'invoices';
              _context10.prev = 1;
              _context10.next = 4;
              return this.http.post("/api/".concat(urlPart, "/update/").concat(invoiceId), _objectSpread({}, invoice, {
                isPetroff: this.config.isPetroff
              }));
            case 4:
              results = _context10.sent;
              return _context10.abrupt("return", _objectSpread({
                success: true
              }, results));
            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](1);
              console.log(_context10.t0);
              return _context10.abrupt("return", {
                success: false
              });
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[1, 8]]);
      }));
      function updateInvoiceSync(_x19, _x20, _x21) {
        return _updateInvoiceSync.apply(this, arguments);
      }
      return updateInvoiceSync;
    }()
  }, {
    key: "updateInvoice",
    value: function updateInvoice(invoiceId, invoiceType, invoice, callback) {
      var urlPart = InvoiceType.getInvoicesPart(invoiceType);
      this.http.post("/api/".concat(urlPart, "/update/").concat(invoiceId), _objectSpread({}, invoice, {
        isPetroff: this.config.isPetroff
      })).then(function (response) {
        callback(response.results);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "deleteInvoices",
    value: function deleteInvoices(invoicesIds, invoiceType, callback) {
      var urlPart = InvoiceType.getInvoicesPart(invoiceType);
      this.http.post("/api/".concat(urlPart, "/delete"), {
        invoicesIds: invoicesIds,
        isPetroff: this.config.isPetroff
      }).then(function (response) {
        callback(response.results);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "deleteInvoicesSync",
    value: function () {
      var _deleteInvoicesSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(invoicesIds, isShopInvoice) {
        var urlPart, results;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              urlPart = isShopInvoice ? 'shopinvoices' : 'invoices';
              _context11.prev = 1;
              results = this.http.post("/api/".concat(urlPart, "/delete"), {
                invoicesIds: invoicesIds,
                isPetroff: this.config.isPetroff
              });
              return _context11.abrupt("return", _objectSpread({
                success: true
              }, results));
            case 6:
              _context11.prev = 6;
              _context11.t0 = _context11["catch"](1);
              console.log(_context11.t0);
              return _context11.abrupt("return", {
                success: false
              });
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[1, 6]]);
      }));
      function deleteInvoicesSync(_x22, _x23) {
        return _deleteInvoicesSync.apply(this, arguments);
      }
      return deleteInvoicesSync;
    }()
  }]);
  return InvoiceService;
}();
export default InvoiceService;